import React, { ReactElement } from 'react';

import { getClassNames } from '../../../../utils/util';

import useTheme from '../../../../hooks/use-theme/useTheme';

import AuthLayout from '../../../../layouts/auth/AuthLayout';

import './registration-success.scss';

const RegistrationSuccess = (): ReactElement => {
  // TODO: Fix after adding types to theme hook
  const { pps } = useTheme();

  return (
    <AuthLayout smallLogo>
      <section className={getClassNames('registration-success', { pps })}>
        <h1 className={getClassNames('registration-success__heading', { pps })}>Thank you, payment was successful</h1>
        <p className={getClassNames('registration-success__message', { pps })}>
          We will be sending you an email shortly with more details.
        </p>
      </section>
    </AuthLayout>
  );
};

export default RegistrationSuccess;
